
(function () {
  'use strict';

  function slidesOf(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return [];
    return Array.prototype.slice.call(viewer.querySelectorAll('[data-media-id]')).filter(function (el) {
      return el.matches('.product__media-item, li');
    });
  }

  function activeIndex(slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function sliderOf(viewer) {
    return viewer.querySelector('[id^="Slider-"]');
  }

  /* Used to depend on scrollLeft > 0, so at the very start the gallery looked
     like a stacked one and at the end it looked like a scroller. That is why
     wrapping worked from the first slide but not from the last. */
  function isScroller(viewer) {
    var slider = sliderOf(viewer);
    if (!slider) return false;
    return slider.scrollWidth - slider.clientWidth > 2;
  }

  function go(gallery, dir) {
    var slides = slidesOf(gallery);
    if (slides.length < 2) return;

    var i = activeIndex(slides);
    /* The wrap itself: -1 from the first lands on the last, +1 from the last
       lands on the first. */
    var next = (i + dir + slides.length) % slides.length;
    var target = slides[next];
    var id = target.dataset.mediaId;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(id, false);
    } else {
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      target.classList.add('is-active');
    }

    /* Keep the thumbnail strip in step — setActiveMedia only syncs it when
       called from a thumbnail click. */
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (thumbs) {
      var t = thumbs.querySelector('[data-target="' + id + '"]');
      if (t) {
        thumbs.querySelectorAll('[data-target]').forEach(function (el) {
          var b = el.querySelector('button');
          if (b) b.setAttribute('aria-current', 'false');
          el.classList.remove('is-active');
        });
        t.classList.add('is-active');
        var btn = t.querySelector('button');
        if (btn) btn.setAttribute('aria-current', 'true');
        if (t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    var slider = gallery.querySelector('[id^="Slider-Gallery"]');
    if (slider && slider.scrollWidth - slider.clientWidth > 2) {
      slider.scrollTo({ left: target.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
    }
  }

  function bind(gallery) {
    if (gallery.dataset.loopBound === '1') return;
    gallery.dataset.loopBound = '1';

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    /* Capture phase: SliderComponent.onButtonClick would otherwise run first
       and clamp at the edges. */
    viewer.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest ? e.target.closest('button[name="next"], button[name="previous"]') : null;
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        go(gallery, btn.name === 'next' ? 1 : -1);
      },
      true
    );

    /* Buttons get disabled at the ends by SliderComponent.update(); with
       looping on there is always somewhere to go. */
    var keepEnabled = new MutationObserver(function () {
      viewer.querySelectorAll('button[name="next"], button[name="previous"]').forEach(function (b) {
        if (b.hasAttribute('disabled')) b.removeAttribute('disabled');
      });
    });
    keepEnabled.observe(viewer, { attributes: true, subtree: true, attributeFilter: ['disabled'] });
    viewer.querySelectorAll('button[name="next"], button[name="previous"]').forEach(function (b) {
      b.removeAttribute('disabled');
    });

    /* Touch swipe — the stacked layout does not scroll, so without this there
       is no way to change media on a phone except the thumbnails. */
    var sx = null;
    var sy = null;
    viewer.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
      },
      { passive: true }
    );
    viewer.addEventListener(
      'touchend',
      function (e) {
        if (sx === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - sx;
        var dy = t.clientY - sy;
        sx = null;
        sy = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return; /* vertical scroll */

        var forward = dx < 0; /* right-to-left swipe = next */

        if (isScroller(viewer)) {
          /* Native scroll clamps at both ends, so the wrap has to be done by
             hand. Everything in between is left to the browser. */
          var slider = sliderOf(viewer);
          var max = slider.scrollWidth - slider.clientWidth;
          var pos = Math.abs(slider.scrollLeft); /* abs: RTL reports negative */

          if (forward && pos >= max - 2) {
            slider.scrollTo({ left: 0, behavior: 'smooth' });
          } else if (!forward && pos <= 2) {
            slider.scrollTo({ left: max, behavior: 'smooth' });
          }
          return;
        }

        go(gallery, forward ? 1 : -1);
      },
      { passive: true }
    );
  }

  function boot(scope) {
    (scope || document).querySelectorAll('media-gallery').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
